import React from "react"
import types from "prop-types"
import { questionShape, sectionShape, userOptionShape } from "utils/propTypeShapes"
import { AnsweredFormOverviewContextProvider } from "contexts/AnsweredFormOverviewContext"
import AnsweredFormOverviewSections from "./AnsweredFormOverviewSections"
import AnsweredFormOverviewDeletedQuestions from "./AnsweredFormOverviewDeletedQuestions"

const DEFAULT_DELETED_QUESTIONS_NOTE = "The following questions were removed."

const AnsweredFormOverview = ({
  answers = {},
  className = "",
  deletedQuestionsNote = DEFAULT_DELETED_QUESTIONS_NOTE,
  deletedQuestions = [],
  newQuestionUuids = [],
  postSectionsContent = null,
  sections = [],
  users = [],
}) => (
  <AnsweredFormOverviewContextProvider
    answers={answers}
    deletedQuestionsNote={deletedQuestionsNote}
    deletedQuestions={deletedQuestions}
    newQuestionUuids={newQuestionUuids}
    sections={sections}
    users={users}
  >
    <div className={className}>
      <AnsweredFormOverviewSections />
      {postSectionsContent}
      <AnsweredFormOverviewDeletedQuestions />
    </div>
  </AnsweredFormOverviewContextProvider>
)

AnsweredFormOverview.propTypes = {
  answers: types.object,
  className: types.string,
  deletedQuestionsNote: types.string,
  deletedQuestions: types.arrayOf(questionShape),
  newQuestionUuids: types.arrayOf(types.string),
  postSectionsContent: types.node,
  sections: types.arrayOf(sectionShape),
  users: types.arrayOf(userOptionShape),
}

export default AnsweredFormOverview
